import { DefinitionDto } from "@app/modules/shared/model/definition.dto";

export class SpeCodeDto extends DefinitionDto {
  public type?: string;
}
